import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";

import { useAlert } from "react-alert";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import { useDispatch, useSelector } from "react-redux";
import { getTopics, deleteTopicData } from "../../../actions/adminTopicActions";
//import { deleteUserData } from '../../../actions/commonActions';

import Loader from "../../Loader";
// import Loader from "react-loader-spinner";

const ListTopics = ({ history, match }) => {
  // const [users, setUsersData] = useState({});
  const alert = useAlert();
  const dispatch = useDispatch();

  const currentSubjectId = match.params.subjectId;
  const handleDeleteTopic = (id) => {
    confirmAlert({
      title: "Confirm to submit",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            dispatch(deleteTopicData(id));
            // history.push(`/admin/topics`);
            alert.success("Topic deleted successfully");
            dispatch(getTopics(currentSubjectId));
          },
        },
        {
          label: "No",
          onClick: () => alert.success("No data deleted"),
        },
      ],
    });
  };

  useEffect(() => {
    dispatch(getTopics(currentSubjectId));
  }, [dispatch]);

  const { topics, user_loading } = useSelector((state) => state);

  return (
    <Fragment>
      {user_loading ? (
        <Loader />
      ) : (
        <Fragment>
          <div className="content-wrapper">
            <section className="content-header">
              <h1>
                Manage
                <small>Topics</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <Link to="/admin">
                    <i className="fa fa-dashboard"></i> Dashboard
                  </Link>
                </li>
                <li>
                  <Link to={`/admin/subjects`}>
                    <i className="fa fa-table"></i> Subjects
                  </Link>
                </li>
                <li className="active">Topics</li>
              </ol>
            </section>

            <section className="content">
              <div className="row">
                <div className="col-xs-12">
                  <div className="box">
                    <div className="box-header">
                      <h3 className="box-title">Topics</h3>
                      <div className="box-tools">
                        <Link
                          to={`/admin/topics/${currentSubjectId}/add`}
                          className="btn btn-success btn-sm"
                        >
                          + Add Topic
                        </Link>
                      </div>
                    </div>
                    <div className="box-body table-responsive no-padding">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Topic Name</th>
                            <th>Status</th>
                            <th>Action</th>
                            <th>Section</th>
                          </tr>
                        </thead>
                        <tbody>
                          {topics.user_loading ? (
                            <Loader />
                          ) : topics.topics != undefined &&
                            topics.topics.length ? (
                            topics.topics.map((item) => (
                              <tr key={item._id}>
                                <td>{item.title}</td>
                                <td>
                                  {item.status === true && (
                                    <span className="badge bg-green">
                                      Active
                                    </span>
                                  )}
                                  {item.status === false && (
                                    <span className="badge bg-yellow">
                                      InActive
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <Link
                                    to={`/admin/topics/${item.subject._id}/edit/${item._id}`}
                                    className="btn btn-success btn-sm"
                                    title="Edit"
                                  >
                                    <i className="fa fa-edit"></i>
                                  </Link>
                                  &nbsp;
                                  <a
                                    className="btn btn-danger btn-sm"
                                    title="Delete"
                                    onClick={() => handleDeleteTopic(item._id)}
                                    key={item._id}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </a>
                                </td>
                                <td>
                                  <Link
                                    to={`/admin/topic-sections/${item._id}`}
                                    className="btn btn-success btn-sm"
                                    title="Topic Section"
                                  >
                                    <i className="fa fa-eye"></i>
                                  </Link>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2">No records found</td>
                            </tr>
                          )}
                        </tbody>
                        <tfoot></tfoot>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Fragment>
      )}
    </Fragment>
  );
};

export default ListTopics;
